<template lang="pug" src="./custom-new-patients-iframe.pug"></template>

<script>
export default {
  props: ['props'],
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// custom-new-patients-iframe.vue?4805e62e